import clsx from 'clsx'
import backgroundPattern from '../assets/background-pattern.png'

interface ReferralCardProps {
  isLoading: boolean
  isError: boolean
  qrCodeError: boolean
  qrCodeDataUrl?: string
  isButtonsDisabled: boolean
  onSave: () => void
  onShare: () => void
}

export function ReferralCard({
  isLoading,
  isError,
  qrCodeError,
  qrCodeDataUrl,
  isButtonsDisabled,
  onSave,
  onShare,
}: ReferralCardProps) {
  return (
    <div className='mt-[30px] flex w-full flex-col gap-[18px]'>
      <p
        className='font-black text-[16px] leading-normal text-[#333] not-italic'
        data-testid='qr-code-title'
      >
        My Referral QR Code
      </p>

      <div className='relative flex h-[279px] w-full flex-col items-center rounded-[28px] bg-[#6e59cd] shadow-[0px_4px_10px_rgba(0,0,0,0.05)]'>
        <div className='absolute inset-0 overflow-hidden rounded-[28px] pointer-events-none'>
          <img
            alt=''
            src={backgroundPattern}
            className='absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 h-full w-full object-cover opacity-30'
          />
        </div>

        <div className='mt-[24px] flex h-[140px] w-[140px] items-center justify-center rounded-[16px] bg-[rgba(255,255,255,0.95)] backdrop-blur-[34.667px] relative z-10'>
          {isError ? (
            <div
              className='size-[121.905px] flex flex-col items-center justify-center gap-[8px] px-[12px]'
              data-testid='qr-code-promotion-error'
            >
              <span className='text-center text-[12px] text-red-600'>
                Failed to load promotion link
              </span>
            </div>
          ) : qrCodeError ? (
            <div
              className='size-[121.905px] flex flex-col items-center justify-center gap-[8px] px-[12px]'
              data-testid='qr-code-error'
            >
              <span className='text-center text-[12px] text-red-600'>
                Failed to generate QR code
              </span>
            </div>
          ) : isLoading || !qrCodeDataUrl ? (
            <div
              className='size-[121.905px] flex items-center justify-center'
              data-testid='qr-code-loading'
            >
              <span className='text-[12px] text-gray-400'>Loading...</span>
            </div>
          ) : (
            <img
              alt='QR Code'
              className='size-[121.905px]'
              src={qrCodeDataUrl}
              data-testid='qr-code-image'
            />
          )}
        </div>

        <p className='relative z-10 mt-[12px] text-center font-medium text-[12px] leading-normal text-[rgba(255,255,255,0.8)] not-italic'>
          Scan to join us
        </p>

        <div className='relative z-10 mb-[27px] mt-auto flex gap-[14px]'>
          <button
            onClick={onSave}
            disabled={isButtonsDisabled}
            className={clsx(
              'flex h-[44px] w-[138px] items-center justify-center rounded-[16px] shadow-[0px_2px_11px_rgba(0,0,0,0.1)]',
              isButtonsDisabled
                ? 'cursor-not-allowed bg-gray-400'
                : 'bg-[#68c19a]',
            )}
            data-testid='save-image-button'
          >
            <span className='font-semibold text-[14px] leading-normal text-white not-italic'>
              Save Image
            </span>
          </button>
          <button
            onClick={onShare}
            disabled={isButtonsDisabled}
            className={clsx(
              'flex h-[44px] w-[143px] items-center justify-center rounded-[16px] shadow-[0px_2px_11px_rgba(0,0,0,0.1)]',
              isButtonsDisabled
                ? 'cursor-not-allowed bg-gray-400'
                : 'bg-[#ed7b5e]',
            )}
            data-testid='share-qr-button'
          >
            <span className='font-semibold text-[14px] leading-normal text-white not-italic'>
              Share QR Code
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}
